import { OrderSubLineListContainer } from "../common/components/v2/OrderAndQuoteSharedStyles";
import OrderSubLineListRow from "./OrderSubLineListRow";
import type { OrderData, OrderLineItemData } from "~/domains/orders/types/modelsV2";

const OrderSubLineList = ({
  data,
  orderData,
  lineItemIndex,
  showDownload,
  onOpenDownload,
  onCloseDownload,
}: {
  data: OrderLineItemData;
  orderData: OrderData;
  lineItemIndex: number;
  onCloseDownload: () => void;
  onOpenDownload: () => void;
  showDownload: boolean;
}) => {
  return (
    <OrderSubLineListContainer gap={1}>
      {data.subEntries?.map((subEntry, index) => (
        <OrderSubLineListRow
          key={`${subEntry.lineNo}-${index}`}
          index={index}
          isLast={index === (data.subEntries?.length ?? 0) - 1}
          subEntry={subEntry}
          data={data}
          orderData={orderData}
          lineItemIndex={lineItemIndex}
          showDownload={showDownload}
          onOpenDownload={onOpenDownload}
          onCloseDownload={onCloseDownload}
        />
      ))}
    </OrderSubLineListContainer>
  );
};

export default OrderSubLineList;
